import { useState } from 'react';
import { WizardPageCombinedProps } from './types';

const usePresenter = (props: WizardPageCombinedProps): WizardPageCombinedProps => {
  const [isTemplateDownloaded, setIsTemplateDownloaded] = useState(false);

  return {
    ...props,
    isCSVTemplateDownloaded: isTemplateDownloaded,
    setIsCSVTemplateDownloaded: setIsTemplateDownloaded,
  };
};

export default usePresenter;
